import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107105Status: 'idle',
    startProcess107105Error: undefined as any,
    loadUserParamsProcess107105Status: 'idle',
    loadUserParamsProcess107105Error: undefined as any,

    process107105List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107105 = createAsyncThunk('process107105Slice/startProcess107105', async ({ process107105 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107105/`,
        prepareData(process107105),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107105Status } = getState().process107105Slice
        return startProcess107105Status !== 'pending'
    }
})

export const loadUserParamsProcess107105 = createAsyncThunk('process107105Slice/loadUserParamsProcess107105', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107105/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107105Status } = getState().process107105Slice
        return loadUserParamsProcess107105Status !== 'pending'
    }
})

const Process107105Slice = createSlice({
    name: 'process107105Slice',
    initialState,
    reducers: {
        resetstartProcess107105: (state) => {
            state.job = undefined
            state.startProcess107105Error = undefined
        },
        resetstartProcess107105Error: (state) => {
            state.startProcess107105Error = undefined
        },
        resetloadUserParamsProcess107105: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107105Error = undefined
        },
        resetloadUserParamsProcess107105Error: (state) => {
            state.loadUserParamsProcess107105Error = undefined
        },
        removeFromProcess107105ListById: (state, action) => {
            state.process107105List = state.process107105List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107105ListByIds: (state, action) => {
            state.process107105List = state.process107105List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107105List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107105Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107105List = []
            state.startProcess107105Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107105.pending, (state) => {
            state.startProcess107105Status = 'pending'
            state.startProcess107105Error = undefined
        })
        builder.addCase(startProcess107105.fulfilled, (state, action) => {
            state.startProcess107105Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107105.rejected, (state, action) => {
            state.startProcess107105Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107105Error = action.error.message
            } else {
                state.startProcess107105Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107105.pending, (state) => {
            state.loadUserParamsProcess107105Status = 'pending'
            state.loadUserParamsProcess107105Error = undefined
        })
        builder.addCase(loadUserParamsProcess107105.fulfilled, (state, action) => {
            state.loadUserParamsProcess107105Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107105.rejected, (state, action) => {
            state.loadUserParamsProcess107105Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107105Error = action.error.message
            } else {
                state.loadUserParamsProcess107105Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107105,
    resetstartProcess107105Error,
    resetloadUserParamsProcess107105,
    resetloadUserParamsProcess107105Error,
    removeFromProcess107105ListById,
    removeFromProcess107105ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107105Slice.actions
export default Process107105Slice.reducer
